<h3> {{'toolbar.settings.patch' | translate }} </h3>

<ng-container *ngFor="let patch of patchNotes; let i = index">
    <!--<H3>{{patch.versionnumber}}</H3>-->
    <div style="padding: 10px;" [innerHTML]="patch.text"></div>

</ng-container>
